import { Component, OnInit } from '@angular/core';

import { Validators } from '@angular/forms';
import { EventTypes } from 'src/app/core/constants/event-types';
import { BaseFormModule } from 'src/app/pages/shared/base';
import { SmsSenderAgentChipListSelectSearchComponent } from 'src/app/shared/components/chip-list-select-search/sms-sender-agent-chip-list-select-search.component';
import { CreatePrivateNumbersByRangeCommand } from '../../../../core/api/models';
import { PrivateNumbersFormComponent } from '../private-numbers-form/private-numbers-form.component';
import { PrivateNumbersService } from './../../../../core/api/services/private-numbers.service';

@Component({
  selector: 'app-range-private-numbers-form',
  templateUrl: './range-private-numbers-form.component.html',
  imports: [BaseFormModule, SmsSenderAgentChipListSelectSearchComponent],
})
export class RangePrivateNumbersFormComponent
  extends PrivateNumbersFormComponent
  implements OnInit
{
  //#region Properties

  model: CreatePrivateNumbersByRangeCommand = {};
  override skipChangeUseFormValidationsMethod: boolean = true;

  //#endregion

  constructor(protected currentService: PrivateNumbersService) {
    super(currentService);
  }

  initForm() {
    super.initForm();
    this.form.get('messageSenderInformation').get('useForm').clearValidators();
    this.form.get('messageSenderInformation').get('number').clearValidators();

    this.form
      .get('messageSenderInformation')
      .get('numberStartOfRange')
      .addValidators(Validators.required);
    this.form
      .get('messageSenderInformation')
      .get('numberEndOfRange')
      .addValidators(Validators.required);
  }

  //#region Api

  //Create
  baseCreateApi(model: CreatePrivateNumbersByRangeCommand) {
    this.unSubs();
    this.loading = true;

    this.currentService
      .privateNumbersCreatePrivateNumbersByRangePost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  onSubmit() {
    try {
      if (!this.isValidForm(this.form, this.tagName)) return;
      if (this.loading) return;

      this.checkCreateOrUpdate();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }
}
